import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';

const useTimeTracking = () => {
    const location = useLocation();
  const startTimeRef = useRef(Date.now())
  useEffect(() => {
    return () => {
      const timeSpentSeconds = Math.round(
        (Date.now() - startTimeRef.current) / 1000
      );

      if (window.gtag) {
        window.gtag("event", "time_spent", {
          page_path: location.pathname,
          time_seconds: timeSpentSeconds,
        });
      }

      startTimeRef.current = Date.now();
    };
  }, [location]);
}

export default useTimeTracking